import { getRoutesFromModule } from './product-framework/router/index';
import { getStoresFromModule } from './state/RootStore';
import * as IndustryModule from './product-framework/pages/Industry';
import * as ServiceJobFormModule from './product-framework/pages/ServiceJobForm';
import * as ServiceJobsModule from './product-framework/pages/ServiceJob';
import * as CountryModule from './product-framework/pages/Country';
import * as ServiceSiteModule from './product-framework/pages/ServiceSite';
import * as ServiceAdministratorClientModule from './product-framework/pages/ServiceAdministratorClient';
import * as ServiceAdministratorWarrantyTypeModule from './product-framework/pages/ServiceAdministratorWarrantyType';
import * as ServiceAdministratorRepairSeverityModule from './product-framework/pages/ServiceAdministratorRepairSeverity';
import * as ServiceAdministratorServiceTypesModule from './product-framework/pages/ServiceAdministratorServiceType';
import * as ServiceProviderModule from './product-framework/pages/ServiceProvider';
import * as RuleModule from './product-framework/pages/Rule';
import * as ServiceAdministratorProductLineModule from './product-framework/pages/ServiceAdministratorProductLine';
import * as WorkflowModule from './product-framework/pages/Workflow';
import * as LaborMatrixModule from './product-framework/pages/LaborMatrix';
import * as BrandModule from './product-framework/pages/Brand';
import * as ManagedNumberModule from './product-framework/pages/ManagedNumber';
import * as FlowDefinitionsModule from './product-framework/pages/FlowDefinitions';
import * as InsightConfigModule from './product-framework/pages/InsightConfig';
import * as UserModule from './product-framework/pages/User';
import * as HelpModule from './product-framework/pages/Help';
import * as ApiDocumentationModule from './product-framework/pages/ApiDocumentation';
import * as ServiceDirectoryModule from './product-framework/pages/ServiceDirectory';
import * as ClaimPaymentExportModule from './product-framework/pages/ClaimPaymentExport';
import * as DataExportHistoryModule from './product-framework/pages/DataExportHistory';
import * as IssuesModule from './product-framework/pages/IssuesTracking';
import * as NotificationsModule from './product-framework/pages/Notifications';
import * as InvoiceModule from './product-framework/pages/Invoice';

/* These need to be fetched only once */
/* Define all modules here */
const injectedRoutes = getRoutesFromModule([
  BrandModule,
  ManagedNumberModule,
  FlowDefinitionsModule,
  InsightConfigModule,
  LaborMatrixModule,
  IndustryModule,
  ServiceJobFormModule,
  ServiceJobsModule,
  CountryModule,
  ServiceSiteModule,
  ServiceAdministratorClientModule,
  ServiceAdministratorWarrantyTypeModule,
  ServiceAdministratorRepairSeverityModule,
  ServiceAdministratorServiceTypesModule,
  ServiceAdministratorProductLineModule,
  ServiceProviderModule,
  RuleModule,
  WorkflowModule,
  UserModule,
  HelpModule,
  ApiDocumentationModule,
  ServiceDirectoryModule,
  ClaimPaymentExportModule,
  DataExportHistoryModule,
  IssuesModule,
  NotificationsModule,
  InvoiceModule,
]);

const injectedStores = getStoresFromModule([
  BrandModule,
  ManagedNumberModule,
  FlowDefinitionsModule,
  InsightConfigModule,
  LaborMatrixModule,
  IndustryModule,
  ServiceJobFormModule,
  ServiceJobsModule,
  CountryModule,
  ServiceSiteModule,
  ServiceAdministratorClientModule,
  ServiceAdministratorWarrantyTypeModule,
  ServiceAdministratorRepairSeverityModule,
  ServiceAdministratorServiceTypesModule,
  ServiceAdministratorProductLineModule,
  ServiceProviderModule,
  RuleModule,
  WorkflowModule,
  UserModule,
  ServiceDirectoryModule,
  ClaimPaymentExportModule,
  DataExportHistoryModule,
  IssuesModule,
  InvoiceModule,
]);

export { injectedRoutes, injectedStores };
